import gql from 'graphql-tag';
import { LISTING_PREVIEW_FRAGMENT } from 'listing-details/components/shared/ListingPreview/ListingPreview.queries';
import { LISTING_CONTACT_TAXONOMY } from 'listing-details/hooks/useListingContactPageTracking/useListingContactPageTracking.queries';

export const LISTING_CONTACT_QUERY = gql`
    query getListingContactDetails($listingId: Int!) {
        listing(id: $listingId) {
            listingUris {
                contact
                detail
                success
            }
            section
            emailLead {
                formFields {
                    email
                    name
                    phone
                    postcode
                    status
                }
                uniqueLeadIdentifier
            }
            ...LISTING_PREVIEW_FRAGMENT
            ...LISTING_CONTACT_TAXONOMY
        }
    }
    ${LISTING_PREVIEW_FRAGMENT}
    ${LISTING_CONTACT_TAXONOMY}
`;

export const LISTING_CONTACT_SHOW_CAPTCHA_QUERY = gql`
    query getListingContactShowCaptcha($listingId: Int!) {
        listing(id: $listingId) {
            emailLead {
                showCaptcha
            }
        }
    }
`;
